/**
 * Deterministic hex color for an IFC class name. Stable across sessions
 * so the same class always gets the same default tint until the user
 * overrides it via LayerSettings.modelClassColors.
 */
export function autoClassColor(name: string): string {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < name.length; i++) {
    h ^= name.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  const hue = h % 360;
  const s = 0.55;
  const l = 0.55;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (hue < 60) {
    r = c;
    g = x;
  } else if (hue < 120) {
    r = x;
    g = c;
  } else if (hue < 180) {
    g = c;
    b = x;
  } else if (hue < 240) {
    g = x;
    b = c;
  } else if (hue < 300) {
    r = x;
    b = c;
  } else {
    r = c;
    b = x;
  }
  const toHex = (v: number) => Math.round((v + m) * 255).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/** Resolve the effective color for an IFC class given a saved override list. */
export function resolveClassColor(cls: string, overrides: ReadonlyArray<{ class: string; color: string }>): string {
  const hit = overrides.find((c) => c.class === cls);
  return hit?.color ?? autoClassColor(cls);
}
